// JMUI TODO intestigate whether this file is needed still at all

import type { JobDetailsPreference } from '../types';

import getLogReceivedFlag from './getLogReceivedFlag';
import * as sessionStorage from '../../../utils/sessionstorage';

/**
 * This is meant to be a temporary log emitter while we track down JMREQ-847.
 * If a question was previously asked this session, it will emit a log to
 * /m/rpc/frontendlogging to be captured by mobile's backend.
 */

const STORAGE_KEY = 'JdAnsweredQs';

export const recordQuestionSubmitted = (
    preference: JobDetailsPreference,
    accountKey: string,
): void => {
    const hash = getHashcode(preference, accountKey);
    addStoredValue(hash);
};

export const logIfQuestionReasked = (
    mobtk: string,
    preference: JobDetailsPreference,
    accountKey: string,
): void => {
    const hash = getHashcode(preference, accountKey);
    if (isValStored(hash)) {
        getLogReceivedFlag(mobtk)('jdPreferenceQuestionReasked');
    }
};

const isValStored = (valToCheck: number) => {
    const storedValues = getStoredValues();

    return storedValues.has(valToCheck.toString());
};

const addStoredValue = (valueToStore: number): void => {
    const storedValues = getStoredValues();
    storedValues.add(valueToStore.toString());
    writeSerialized(storedValues);
};

const getStoredValues = (): Set<string> => {
    const rawStoredValue = sessionStorage.get(STORAGE_KEY) ?? '""';

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const parsed = JSON.parse(rawStoredValue);

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return new Set(parsed);
};

const writeSerialized = (setOfVals: Set<string>): void => {
    const serialized = JSON.stringify(Array.from(setOfVals.keys()));
    sessionStorage.set(STORAGE_KEY, serialized);
};

// https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0
const getHashcode = (preference: JobDetailsPreference, accountKey: string): number => {
    const str = `${preference.suid} ${accountKey}`;

    let h = 0;
    for (let i = 0; i < str.length; i++) {
        h = Math.imul(31, h) + str.charCodeAt(i);
    }

    return Math.abs(h);
};
